var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnDemand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 37@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "On-Demand",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Live-Recorded-Videos",
    transform: "translate(-388.000000, -195.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(388.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    cx: 31,
    cy: 31,
    r: 29.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F22B5D",
    cx: 31,
    cy: 31,
    r: 17
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnDemand);
export default __webpack_public_path__ + "static/media/onDemand.0a8a01e0ed5e163735459dfb2c444816.svg";
export { ForwardRef as ReactComponent };